import { EditorInput } from '../EditorInput';
import { customizeCraftJsComponent } from '../../helpers';

export const EditorFullNameInput = customizeCraftJsComponent(EditorInput, {
	name: 'Full Name Input',
	props: {
		name: 'fullName',
		type: 'text',
		placeholder: 'Full Name',
		label: 'Full Name'
	}
});
